// Operational views use the current booking; issued invoices keep their own snapshot.
export const tripOf = row => row.trip || (row.bill && row.bill.invoice ? row.bill.invoice.trip : { persons: [] })
export const recipientOf = row => row.bill && row.bill.invoice ? row.bill.invoice.recipient : row.recipient
export const referenceOf = row => row.bill ? row.bill.invoice ? row.bill.invoice.reference : row.bill.externalReference || "" : ""
export const amountOf = row => row.bill ? row.bill.invoice ? row.bill.invoice.pricing.amountCents : row.bill.externalAmountCents : row.pricing.baseCents
export const statusOf = row => !row.bill ? "none" : row.bill.isPaid ? "paid" : "open"
export const normalized = value => String(value || "").toLocaleLowerCase("de-CH").normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "")

export function filterRows(rows, filters) {
  const query = normalized(filters.search)
  return rows.filter(row => {
    const trip = tripOf(row)
    if (filters.year && (!trip.start || trip.start.slice(0, 4) !== filters.year)) return false
    if (filters.room && trip.room !== filters.room) return false
    if (filters.status && statusOf(row) !== filters.status) return false
    if (filters.sent === "yes" && !(row.bill && row.bill.isSent)) return false
    if (filters.sent === "no" && row.bill && row.bill.isSent) return false
    if (filters.from && (!trip.end || trip.end < filters.from)) return false
    if (filters.to && (!trip.start || trip.start > filters.to)) return false
    const admin = row.management
    if (filters.studio && (!admin || admin.studio !== filters.studio)) return false
    if (filters.hotel === "yes" && (!admin || !admin.hotelSent)) return false
    if (filters.hotel === "no" && (!admin || admin.hotelSent)) return false
    if (filters.referral && (!admin || (admin.referral.referred === null ? "unknown" : admin.referral.referred ? "yes" : "no") !== filters.referral)) return false
    const invoice = row.bill && row.bill.invoice
    const terms = [row.id, row.recipient && row.recipient.name, recipientOf(row).name, ...trip.persons, trip.room, trip.subtitle, referenceOf(row), invoice && invoice.number, trip.start, trip.end,
      admin && admin.contact.email, admin && admin.contact.phone, admin && admin.studio, admin && admin.referral.recommendedBy]
    return !query || terms.some(value => normalized(value).includes(query))
  })
}

export function parseAmount(value) {
  const cleaned = String(value == null ? "" : value).trim().replace(/[\s'’]/g, "").replace(",", ".")
  if (!/^\d+(?:\.\d{1,2})?$/.test(cleaned)) return null
  const parts = cleaned.split(".")
  const result = Number(parts[0]) * 100 + Number((parts[1] || "").padEnd(2, "0"))
  return Number.isSafeInteger(result) && result > 0 && result <= 99999999999 ? result : null
}
